var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-flex flex-row justify-content-center align-items-center",staticStyle:{"height":"600px"}},[_c('img',{attrs:{"src":"/img/spinner.gif","height":"100","alt":""}})])])])
}]

export { render, staticRenderFns }